<template>
    <div class="popup">
        <div class="popup-header">
            <p class="mb-0 fs-17 fw-b">
                {{ $t(`${$options.name}.title`) }}
            </p>
            <div class="close" @click="$emit('close')"></div>
        </div>
        <div class="popup-content pt-0 h-auto">
            <el-form @submit="submit(true)" :disabled="users.filter(u => (u.first_name !== '' && u.email !== '')).length === 0" :error="server_error" :loading="loading" :success="success" :button-text="`${$options.name}.button`">
                <el-invite v-model="users" :users="[]" />
            </el-form>
        </div>
    </div>
</template>

<script>
import { ElInvite } from "@/components/elements/_index";

import HasForm from '@/components/forms/has-form';

export default {
    name: 'popups.general.invite',

    components: {
        ElInvite,
        ElForm: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElForm")
    },

    mixins: [HasForm],

    props: {
        modelId: {
            type: Number,
            required: true,
            validator: function (value) {
                return value > 0
            }
        },

        type: {
            type: String,
            required: true,
            validator: function (value) {
                return ['workspace', 'object', 'container'].indexOf(value) !== -1
            }
        },

    },

    data() {
        return {
            users: [],
            error: false,
        };
    },

    methods: {
        submit() {
            if (this.users.length === 0) {
                this.open = false;
                return;
            }

            let users = []
            this.users.forEach((user) => {
                if (user.email.replace(/\s/g, "") !== "") {
                    if (this.type === 'workspace') user.is_workspace_admin = user.role
                    if (this.type === 'container') user.is_container_admin = user.role
                    users.push(user)
                }
            })

            this.loading = true;
            this.$store.dispatch(`${this.type}/createUser`, { model_id: this.modelId, users: users })
                .then(() => {
                    this.users = [];
                    this.handleSuccess()
                    this.$emit('close')
                })
                .catch(e => this.handleError(e));
        },
    }
}
</script>